/// <reference path="../../../../typings/index.d.ts" />
/// <reference path="../../components/baseclasses/guid.ts" />
/// <reference path="../../components/models/meevo.model.custom.ts" />

module Meevo.Plugins.UsageReasons {
	"use strict";

	export class UsageReasonsContext extends Meevo.Components.BaseClasses.DataMaintenanceContextBase {

		constructor(appSettings: Meevo.Components.Common.IAppSettings,
			dataService: Meevo.Components.BaseClasses.IDataService,
			modalService: Meevo.Components.Modal.IModalService,
			identityService: Meevo.Components.Common.IIdentityService,
			loggingService: Meevo.Components.Logging.ILoggingService,
			securityChecker: Meevo.Components.Common.ISecurityService,
			trackingService: Meevo.Components.Tracking.ITrackingService) {

			super(appSettings, dataService, modalService, identityService, loggingService, securityChecker, trackingService);

			this.baseEndpoint = appSettings.API_ENDPOINTS.usageReasons;
			this.sectionTemplatePath = "app/plugins/usageReasons/sectionViews/";

			this.buildCrudSecurityKeys(this.securityKeys.INVENTORY_USAGEREASON_TAB_MAIN);
			this.entityType = 'UsageReason';
		}

		initializeSections(): void {
			var tabSecKey = this.securityKeys.INVENTORY_USAGEREASON_TAB_MAIN + Meevo.Components.Common.SecurityParts.KEY_PART_READ;
			if (this.securityChecker.hasSecurityDenyOrGrant(tabSecKey)) {
				this.sections.push(new MainSection(0, "SECTION_USAGE_REASONS_MAIN", "main.html", true, false,
					this.appSettings.API_ENDPOINTS.usageReasons, "",
					this.loggingService, this.dataService, this.identityService, Meevo.Model.NounEnum.UsageReasonMain, null, tabSecKey));
			}
		}

		initializeHeader(model: any): void {
			this.headerContent = model.displayName;
			this.businessTypeDetail = model.businessTypeDetail;
		}

		postCopy(): void {
			super.postCopy();
			let model = this.castModel<Model.DataMaintenanceWithLanguage>();
			model.displayName = undefined;
		}

	}
}